/// <reference types="vite/client" />

// Base URL for backend API calls.
// Dev: empty string — vite proxies /api/* to the local wrangler server (:8787).
// Prod: the team worker, whose CORS allowlist includes the public-site origin.
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.PROD ? 'https://team.tifpaconsulting.com' : '');
